import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToasts } from '@scope/scope-one-ui/core/Messages/context';
import { Box, Dialog, Select } from '@scope/scope-one-ui/core';
import { Rating, ContractType, ContractTypes, SubscriptionRatingType } from '../types';
import { setRatingContractType } from '../services/rsrService';

type SetContractTypeProps = {
  rating?: Rating;
  open: boolean;
  onClose: (set: boolean) => void;
  ratingType: SubscriptionRatingType;
};

export const SetContractTypeModal: FC<SetContractTypeProps> = ({
  open,
  onClose,
  rating,
  ratingType,
}) => {
  const { t } = useTranslation();
  const { error, success } = useToasts();

  const [selectedContractType, setSelectedContractType] = useState<ContractType>();

  const contractTypes = [
    { value: ContractTypes.REQUESTED, label: t('ADMIN.RSR.INVESTOR_REQUESTED') },
    { value: ContractTypes.SOLICITED, label: t('ADMIN.RSR.ISSUER_SOLICITED') },
  ];

  const handleContractTypeChange = (selected: ContractType) => {
    setSelectedContractType(selected);
  };

  const setContractType = async () => {
    if (rating && selectedContractType) {
      try {
        const result = await setRatingContractType(
          ratingType,
          [rating.entityId],
          selectedContractType,
        );
        if (result) {
          success({ title: '', content: t('ADMIN.SNACKS.RATING_CONTRACT_TYPE_SET') });
        }
      } catch (e) {
        error({ title: '', content: t('ADMIN.SNACKS.RATING_CONTRACT_TYPE_FAILED') });
      }
    }
    onClose(true);
  };

  useEffect(() => {
    setSelectedContractType(undefined);
  }, [rating]);

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      title="Contract Type"
      confirmLabel="Submit"
      onConfirm={setContractType}
    >
      <Box p={3}>
        <Select
          onChange={(value) => handleContractTypeChange(value as ContractType)}
          value={selectedContractType || rating?.contractType}
          options={contractTypes}
        />
      </Box>
    </Dialog>
  );
};
